import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
@Directive({
  selector: '[isPhoneOrNull]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidPhoneAllowNullDirective, multi: true }]
})
export class ValidPhoneAllowNullDirective {

  constructor() { }

  public validate(control: AbstractControl): { [key: string]: any } {

    let phoneNumber = /^([0-9]+)$/;
    let valid = phoneNumber.test(control.value);
    if (control.value === null || control.value === undefined || control.value.trim() === "") {
      // control.setValue("");
      return null;
    }
    else {
      if (valid) {
        if(control.value.length!=10)
        {
          return { 'isPhone': true };
        }
        else
        {
          return null;
        }
      }
      else {
        control.setValue("");
        return { 'isPhone': true };
      }
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/valid-phone-allow-null.directive.ts